import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import EntityAdminPageContent from '../components/pages/org-unit/view/content';
import NotFoundPage from './NotFoundPage.js';
import objectAssign from 'object-assign';

const OrgUnitPage = (props) => {
  let canSeeEntityAdminPage = false;
  let entityAdminRights = {};
  if (props.hasEntityAdminRights != undefined && props.isAdmin != undefined) {
    // This includes server admin & mr admin
    // canSeeEntityAdminPage =
    //   props.hasEntityAdminRights.isOrgAdmin ||
    //   props.hasEntityAdminRights.isServiceAdmin ||
    //   props.hasEntityAdminRights.isMeetingRoomAdmin ||
    //   props.isAdmin;

    // Exclude service admin & mr admin
    canSeeEntityAdminPage = props.hasEntityAdminRights.isOrgAdmin || props.isAdmin;
    entityAdminRights = {
      isAdmin: props.isAdmin,
      isOrgAdmin: props.hasEntityAdminRights.isOrgAdmin,
      isMeetingRoomAdmin: props.hasEntityAdminRights.isMeetingRoomAdmin,
      isServiceAdmin: props.hasEntityAdminRights.isServiceAdmin,
      isSystemAdmin: props.isSystemAdmin,
      isSysAdminAllowedToDeleteOrg: props.isSysAdminAllowedToDeleteOrg,
    };
  }

  return props.redirectToPageNotFound || !canSeeEntityAdminPage ? (
    <NotFoundPage dispatch={props.dispatch} />
  ) : (
    <div>
      <EntityAdminPageContent
        organisations={props.organisations}
        userId={props.userId}
        showOrganisationalUnitLogoImageModal={props.showOrganisationalUnitLogoImageModal}
        showDeleteOrganizationModal={props.showDeleteOrganizationModal}
        meetingRoomsDeletionStatus={props.meetingRoomsDeletionStatus}
        waitingAreasDeletionStatus={props.waitingAreasDeletionStatus}
        organizationDeletionStatus={props.organizationDeletionStatus}
        showCreateWaitingAreaModal={props.showCreateWaitingAreaModal}
        showCreateMeetingRoomModal={props.showCreateMeetingRoomModal}
        showOrgUnitGeneralInfoModal={props.showOrgUnitGeneralInfoModal}
        showOrgUnitSupportContactModal={props.showOrgUnitSupportContactModal}
        showOrgUnitBeforeCallsWAModal={props.showOrgUnitBeforeCallsWAModal}
        showOrgUnitShareLinkWAModal={props.showOrgUnitShareLinkWAModal}
        showCreateOUModal={props.showCreateOUModal}
        selectedOrgUnit={props.selectedOrgUnit}
        selectedWaitingArea={props.selectedWaitingArea}
        selectedMeetingRoom={props.selectedMeetingRoom}
        entitySearchForm={props.entitySearchForm}
        entityStats={props.entityStats}
        entityAdminRights={entityAdminRights}
        previousPage={props.previousPage}
        storedFilterValue={props.storedFilterValue}
        isWAEntryPointAdditionalMsgAllowed={props.isWAEntryPointAdditionalMsgAllowed}
        isConsultNowFeatureEnabled={props.isConsultNowFeatureEnabled}
        dispatch={props.dispatch}
        showOURecordingSettingModal={props.showOURecordingSettingModal}
        showOuDefaultGcSettingsModal={props.showOuDefaultGcSettingsModal}
        isRecordingFeatureEnabled={props.isRecordingFeatureEnabled}
        OURecordingFeature={props.OURecordingFeature}
        WAOURecordingEnable={props.WAOURecordingEnable}
        isSystemAdmin={props.isSystemAdmin}
      />
    </div>
  );
};
function mapStateToProps(state) {
  return {
    organisations: state.organisationsReducer.organisations,
    isConsultNowFeatureEnabled: state.usersReducer.isConsultNowFeatureEnabled,
    showCreateWaitingAreaModal: state.modalReducer.showCreateWaitingAreaModal,
    showCreateMeetingRoomModal: state.modalReducer.showCreateMeetingRoomModal,
    isAdmin: state.usersReducer.userProfile && state.usersReducer.userProfile.isAdmin,
    hasEntityAdminRights: state.usersReducer.userProfile && state.usersReducer.userProfile.hasEntityAdminRights,
    userId: state.usersReducer.userProfile.id,
    showOrganisationalUnitLogoImageModal: state.modalReducer.showOrganisationalUnitLogoImageModal,
    showDeleteOrganizationModal: state.modalReducer.showDeleteOrganizationModal,
    meetingRoomsDeletionStatus: state.organisationsReducer.meetingRoomsDeletionStatus,
    waitingAreasDeletionStatus: state.organisationsReducer.waitingAreasDeletionStatus,
    organizationDeletionStatus: state.organisationsReducer.organizationDeletionStatus,
    hasOrganisations:
      (state.usersReducer.fetchingUserProfile && state.usersReducer.userProfile.hasOrganisations == undefined) ||
      state.usersReducer.userProfile.hasOrganisations,
    showOrgUnitGeneralInfoModal: state.modalReducer.showOrgUnitGeneralInfoModal,
    showOrgUnitSupportContactModal: state.modalReducer.showOrgUnitSupportContactModal,
    showOrgUnitBeforeCallsWAModal: state.modalReducer.showOrgUnitBeforeCallsWAModal,
    showOrgUnitShareLinkWAModal: state.modalReducer.showOrgUnitShareLinkWAModal,
    showCreateOUModal: state.modalReducer.showCreateOUModal,
    selectedOrgUnit: state.organisationsReducer.selectedOrgUnit,
    selectedWaitingArea: state.waitingAreaReducer.selectedWaitingArea,
    selectedMeetingRoom: state.meetingRoomReducer.selectedMeetingRoom,
    entitySearchForm: state.organisationsReducer.entitySearchForm,
    entityStats: state.organisationsReducer.entityStats,
    previousPage: state.navigationBarReducer.previousPage,
    storedFilterValue: state.organisationsReducer.storedFilterValue,
    isWAEntryPointAdditionalMsgAllowed: state.usersReducer.userProfile.isWAEntryPointAdditionalMsgAllowed,
    showOURecordingSettingModal: state.modalReducer.showOURecordingSettingModal,
    showOuDefaultGcSettingsModal: state.modalReducer.showOuDefaultGcSettingsModal,
    isRecordingFeatureEnabled: state.usersReducer.isRecordingFeatureEnabled,
    OURecordingFeature: state.organisationsReducer.OURecordingFeature,
    WAOURecordingEnable: state.organisationsReducer.isRecordingEnabled,
    isSystemAdmin: state.usersReducer.userProfile && state.usersReducer.userProfile.isSystemAdmin,
    isSysAdminAllowedToDeleteOrg:
      state.usersReducer.userProfile && state.usersReducer.userProfile.isSysAdminAllowedToDeleteOrg,
  };
}
export default connect(mapStateToProps, null)(OrgUnitPage);
